export const createProductMapKey = (sku: string, handle: string): string => `${sku}@${handle}`;

export const isSkuVariantOfBase = (sku: string, baseSku: string): boolean =>
  sku === baseSku || sku.startsWith(`${baseSku}-`);

export const matchesAnyBaseSku = (sku: string, baseSkus: string[]): boolean =>
  baseSkus.some((baseSku) => isSkuVariantOfBase(sku, baseSku));